import TableOperations from 'mini-mail-list-table-operations';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { action } from 'satcheljs/lib/legacy';
import { errorThatWillCauseAlert } from 'owa-trace';
import { fetchRichContentForRows } from './helpers/fetchRichContentForRows';
import { getConversationOrItemIdFromRow } from 'mini-mail-list-table-operations/lib/utils/getConversationOrItemIdFromRow';
import type { MailListRowDataType } from 'mini-mail-list-store/lib/store/schema/MailListRowDataType';
import { shouldSkipProcessRow } from './shouldProcessServerPayload';

/**
 * Process FindConversation/FindItem response and merge them to the top of the given TableView
 * @param rows to be merged
 * @param tableView to merge results in
 * @param totalRowsInViewInResponse - total rows in the table returned from server
 */
export const mergeRowResponseFromTop = action('mergeRowResponseFromTop')(
    function mergeRowResponseFromTop(
        rows: MailListRowDataType[],
        tableView: TableView,
        totalRowsInViewInResponse: number
    ) {
        const rowList: MailListRowDataType[] = rows || [];

        let insertIndex = 0;
        try {
            for (const row of rowList) {
                // Check if row should be skipped
                if (shouldSkipProcessRow(row, tableView)) {
                    continue;
                }

                if (TableOperations.containsRow(tableView, getConversationOrItemIdFromRow(row))) {
                    // If existing, move row up from its current position to insert index
                    TableOperations.updateRow(insertIndex, row, tableView);
                } else {
                    // Otherwise add new row to list
                    TableOperations.addRow(insertIndex, row, tableView);
                }

                insertIndex++;
            }
        } catch (error) {
            errorThatWillCauseAlert('[mergeRowResponseFromTop] Error merging rows from top', error);
        }

        // Always update totalRowsInView after making a find request, to allow us to calculate whether this table can load more
        tableView.totalRowsInView = totalRowsInViewInResponse;

        fetchRichContentForRows(tableView.id);
    }
);
